
export default function(id, values = []) {
    const self = this;

    self.id = id;

    self.values = values;


    self.getId = () => {
      return self.id;
    };


    self.valueExists = (value) => {
        if(self.values.includes(value)) {
            return true;
        }
        return false;
    };

    self.getValue = (id) => {
        return self.values[self.values.indexOf(id)]
    };

    self.getValues = () => {
        return self.values;
    };

    self.setValues = (values) => {
        self.values = values;
    };

    self.addValue = (value) => {
        if(!self.valueExists(value)) {
            self.values.push(value);
        }
    };

    self.addValues = (values) => {
        for(let value of values) {
            self.addValue(value);
        }
    };

    self.removeValue = (value) => {
        if(self.valueExists(value)) {
            self.values.splice(self.values.indexOf(value), 1);
        }
    };


}


// WEBPACK FOOTER //
// ./resources/js/MrMovie/Filters/ActiveFilter.js